module.exports = __webpack_public_path__ + "img/crew-img-1.e9b2cf05.png";